import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useVault } from "@/context/VaultContext";
import { deleteNote } from "@/lib/store";
import { PinPad } from "./PinPad";

export function DeleteNoteDialog({ note, open, onOpenChange }) {
  const { verifyPin, setNoteId, refresh } = useVault();
  const [error, setError] = useState("");
  const [step, setStep] = useState("confirm");
  useEffect(() => { if (open) { setStep("confirm"); setError(""); } }, [open]);
  const done = async (pin) => {
    const err = await verifyPin(pin);
    if (err) { setError(err); return false; }
    try {
      await deleteNote(note.id);
      onOpenChange(false); setNoteId(null); await refresh();
      toast.success("Note deleted from this device");
    } catch (e) {
      toast.error("Could not delete note", { description: e.message });
    }
    return true;
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="delete-note-dialog">
        <DialogHeader>
          <DialogTitle>Delete “{note.title || "this note"}”?</DialogTitle>
          <DialogDescription>This removes the note, its versions and files from this device. Existing exports are unaffected.</DialogDescription>
        </DialogHeader>
        {open && step === "confirm" && (
          <div className="flex justify-end gap-2">
            <Button variant="ghost" onClick={() => onOpenChange(false)} data-testid="delete-cancel-button">Cancel</Button>
            <Button variant="destructive" onClick={() => setStep("pin")} data-testid="delete-confirm-button">Yes, delete</Button>
          </div>
        )}
        {open && step === "pin" && <PinPad testPrefix="delete-pin" title="Confirm with PIN" error={error} onComplete={done} />}
      </DialogContent>
    </Dialog>
  );
}
